import {ResolvedPermission} from '../../ResolvedPermission'
import type {ToolCallCancelledState} from '@microsoft/agent-host-protocol'
import {stringOrMarkdownToText} from '@github-ui/ahp-relay/ahp-session-selectors'

/** Renders a denied tool call (cancelled with reason `denied`/`result-denied`) as a permission entry. */
export function AhpPermission({toolCall}: {toolCall: ToolCallCancelledState}) {
  const description = stringOrMarkdownToText(toolCall.invocationMessage) ?? toolCall.displayName

  return (
    <ResolvedPermission
      kind={toolCall.toolName}
      toolName={toolCall.toolName}
      description={description}
      detail={stringOrMarkdownToText(toolCall.reasonMessage)}
      state="denied"
      denialKind="denied-interactively-by-user"
    />
  )
}
